import { ExploreContentHeader } from "@/ui/components/explore/ExploreContentHeader";

const StoryMeta = {
  title: "Components/Explore/Content Header",
  component: ExploreContentHeader,
  argTypes: {},
  args: {},
};

export default StoryMeta;

export const Primary = {};
